// @flow @format
import {handleActions} from 'lib/redux-actions';

// keeps track of the currently selected entities of the file explorer.
export type State = {
	+machineId: ?string,
	+fileNodeId: ?string,
	+repositoryId: ?string,
	+userId: ?string,
	+downloadId: ?string,
};

type Action = {
	+type: string,
	+entity: string,
	+payload: ?string,
};

export const SELECT_ENTITY = 'SELECT_ENTITY';

function select(entity: $Keys<State>, payload: ?string): Action {
	return {type: SELECT_ENTITY, entity, payload};
}

export const selectUser = (id: ?string): Action => select('userId', id);
export const selectMachine = (id: ?string): Action => select('machineId', id);
export const selectFileNode = (id: ?string): Action => select('fileNodeId', id);
export const selectRepository = (id: ?string): Action =>
	select('repositoryId', id);

export const initialState = {
	machineId: null,
	fileNodeId: null,
	repositoryId: null,
	userId: null,
	downloadId: null,
};

const reducer = handleActions(
	{
		[SELECT_ENTITY]: (state: State, action: Action): State => {
			if (state[action.entity] === action.payload) {
				return state;
			}

			return {
				...state,
				[action.entity]: action.payload,
			};
		},
	},
	initialState
);

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/selection.js